/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: Specify types so these disables are unnecessary
import React from 'react';
import {
  Grid, TextField, Typography, Box, CircularProgress,
  Paper, Card, CardContent, CardHeader, Divider, Button, Tooltip, IconButton,
  InputAdornment,
} from '@material-ui/core';
import ClearIcon from '@material-ui/icons/Clear';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import Alert from '@material-ui/lab/Alert';
import { useForm } from 'react-hook-form';
import { debounce } from 'lodash';
import type { AxiosError } from 'axios';
import axios from 'axios';
import useSWR from 'swr';
import {
  useParams, useNavigate,
} from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { useCookies } from 'react-cookie';
import useEventListener from '../../lib/useEventListener';
import deselectElementPreventDefaultAndBlur from '../../lib/deselectAndBlur';
import type {
  IScannedRepair, IClaim, IRepairItem, IRepairItemReactHookFormObject, AdditionalField, IMarkingAcceptableBounds,
} from './MarkingInterfaces';
import RepairCard from './RepairCard';
import RepairItem from './RepairItem';
import ChipSelect from '../ChipSelect';
import WarrantyDialog from './WarrantyDialog';
import MarkingModal from './MarkingModal';
import getBrands from '../../lib/SWRfetchers/getBrands';
import getManufacturers from '../../lib/SWRfetchers/getManufacturers';
import getSettingTypes from '../../lib/SWRfetchers/getSettingTypes';
import getMetalTypes from '../../lib/SWRfetchers/getMetalTypes';
import getWritingInstrumentTypes from '../../lib/SWRfetchers/getWritingInstrumentTypes';
import getRepairItemTypes from '../../lib/SWRfetchers/getRepairItemTypes';
import NavigationDropdown from '../navigation/NavigationDropdown';
import MarkingAdditionalField from './MarkingAdditionalField';

const Marking: React.FC<{ hasWarranty: boolean }> = ({ hasWarranty = true }) => {
  const { enqueueSnackbar } = useSnackbar();
  const {
    control,
    handleSubmit,
    trigger,
    register,
    formState,
    setValue,
  } = useForm({
    mode: 'all',
    criteriaMode: 'all',
  });

  // trigger swr dropdown calls on initial load of marking page
  // to start loading them before any repair is put in
  /* eslint-disable @typescript-eslint/no-unused-vars */
  const { brands } = getBrands();
  const { manufacturers } = getManufacturers();
  const { settingTypes } = getSettingTypes();
  const { metalTypes } = getMetalTypes();
  const { writingInstrumentTypes } = getWritingInstrumentTypes();
  const { repairItemTypes } = getRepairItemTypes();
  /* eslint-enable @typescript-eslint/no-unused-vars */
  const itemValueInputRef = React.useRef<HTMLInputElement>(null);
  const [itemValueError, setItemValueError] = React.useState<boolean>(false);
  const [repairId, setRepairId] = React.useState<string>();
  const [showLabelRequiredModal, setShowLabelRequiredModal] = React.useState(false);
  const [showValueRequiredModal, setShowValueRequiredModal] = React.useState(false);
  const [showWarrantyModal, setShowWarrantyModal] = React.useState(false);
  const [items, setItems] = React.useState<any[]>([{}]);
  const [firstLabel, setFirstLabel] = React.useState<string | undefined>();
  const [repairUpdating, setRepairUpdating] = React.useState<boolean>(false);
  const [openRepairProcessing, setOpenRepairProcessing] = React.useState<boolean>(false);
  const [repairValueProcessing, setRepairValueProcessing] = React.useState<boolean>(false);
  const navPages = ['Current', 'Estimating', 'Photography'];
  const navigate = useNavigate();
  const [cookies, setCookie] = useCookies<string, { markerNextPage?: string }>(['markerNextPage']);
  const [markingAcceptableBounds, SetMarkingAcceptableBounds] = React.useState<IMarkingAcceptableBounds>();

  const fetcher = async (url: string, currentRepairId: string) => {
    const res = await axios.get<IScannedRepair>(url, {
      params: {
        repairId: currentRepairId,
      },
    })
      .then((response) => {
        setItems(response.data.repairItems);
        const resp = response.data;
        return resp;
      });
    setOpenRepairProcessing(false);
    return res;
  };

  // The marking page uses the data from the initial load because is on a form where we don't want to override the users input.
  // Therefore if a previous load of the same repairId before a repair item was actually a placeholder with nulls,
  // the first repair item will once again load in blank despite it having real data.
  // By the time useSWR has revalidated the API call, the initial data from the cached in the form is already set.
  // Workaround from https://github.com/vercel/swr/discussions/456#discussioncomment-25602
  const random = React.useRef(Date.now());
  const { data, mutate } = useSWR<IScannedRepair>(repairId
    ? ['/marker/getRepair', repairId, random]
    : null,
  (url, currentRepairId) => fetcher(url, currentRepairId),
  {
    revalidateOnFocus: false,
    revalidateOnMount: true,
    revalidateOnReconnect: false,
    refreshWhenOffline: false,
    refreshWhenHidden: false,
    refreshInterval: 0,
  });

  const handleRedoStateChange = (isRedo: boolean) => {
    axios.post<{ repairId: string, isRedo: boolean }>('/marker/updateIsRedo', {
      repairId,
      isRedo,
    })
      .then((response) => {
        enqueueSnackbar(`Repair redo status successfully set to ${String(response.data.isRedo)}`, { variant: 'success' });
        mutate().catch((e) => { enqueueSnackbar(e, { persist: false, variant: 'error' }); });
      })
      .catch((error: AxiosError) => {
        enqueueSnackbar(error?.response?.data, { persist: false, variant: 'error' });
      });
  };

  const handleAddNewItemClick = () => {
    const currentLength = items.length;
    const newLength = currentLength + 1;
    if (newLength > currentLength) {
      setItems([...items, ...Array(newLength - currentLength)]);
    } else {
      const newArray = items.splice(0, Math.abs(newLength - currentLength));
      setItems([...newArray]);
    }
  };

  const handleWarrantyDelete = (claim: IClaim) => {
    axios.post('/marker/removeWarranty', {
      repairId,
      claimId: claim.claimId,
    })
      .then(() => {
        mutate().catch((e) => { enqueueSnackbar(e, { persist: false, variant: 'error' }); });
      })
      .catch((error: AxiosError) => {
        enqueueSnackbar(error?.response?.data, { persist: false, variant: 'error' });
      });
  };

  const handleWarrantyAdd = (maintenanceAgreementId: string) => {
    axios.post('/marker/attachWarranty', {
      repairId,
      maintenanceAgreementId,
    })
      .then(() => {
        mutate().catch((e) => { enqueueSnackbar(e, { persist: false, variant: 'error' }); });
      })
      .catch((error: AxiosError) => {
        enqueueSnackbar(error?.response?.data, { persist: false, variant: 'error' });
      });
  };

  const handleRepairValueChange = (repairValue: string) => {
    setRepairValueProcessing(true);
    axios.post('marker/updateRepairValue', {
      repairId,
      repairValue,
    })
      .then(() => {
        enqueueSnackbar(`Item value successfully set to $${repairValue}`, { variant: 'success' });
        mutate().catch((e) => { enqueueSnackbar(e, { persist: false, variant: 'error' }); });
        setRepairValueProcessing(false);
      })
      .catch((error: AxiosError) => {
        enqueueSnackbar(`Item value failed to set because of the following error ${JSON.stringify(error?.response)}`, { variant: 'error' });
        setRepairValueProcessing(false);
      });
  };

  const handlePageSelectedChange = (page: string) => {
    setCookie('markerNextPage', page);
  };

  const isFirstItemLabelRequired = (itemIndex: number) => {
    if (itemIndex > 0
      && (
        !firstLabel
        || data?.repairItems.find((item) => Number.parseInt(item.itemNumber, 10) === 1)?.label === undefined)) {
      setShowLabelRequiredModal(true);
      return true;
    }
    return false;
  };

  const closeMarkingModal = () => {
    setShowLabelRequiredModal(false);
  };

  const scanRepair = (scannedBarcode: string) => {
    if (scannedBarcode !== data?.barcode) {
      setRepairId(undefined);
      setOpenRepairProcessing(true);
      mutate(undefined).catch((e) => { enqueueSnackbar(e, { persist: false, variant: 'error' }); });
      axios.get<string>('/marker/scanRepair', {
        params: {
          barcode: scannedBarcode,
        },
      })
        .then((response: { data: any; }) => {
          setRepairId(response.data.repairId);
          mutate().catch((e) => { enqueueSnackbar(e, { persist: false, variant: 'error' }); });
        })
        .catch((error: AxiosError) => {
          enqueueSnackbar(error?.response?.data, { persist: false, variant: 'error' });
          setOpenRepairProcessing(false);
        });
    }
  };

  const saveRepairItem = async (ri: IRepairItem): Promise<string> => {
    if (ri.index === undefined) {
      enqueueSnackbar('There was a problem saving the repair items. Please refresh the page and try again.', { variant: 'error' });
      throw new Error(`Missing index needed for save ${JSON.stringify(ri)}`);
    }
    if (data?.repairValue === undefined || data?.repairValue <= 0) {
      setShowValueRequiredModal(true);
      throw new Error('Missing item value needed for save');
    }
    const result = await axios.post<{ repairItemId: string, }>('marker/addRepairItem', {
      repairId,
      repairItem: ri,
    })
      .then((response) => {
        const saveItem = items;
        if (ri.index !== undefined) {
          saveItem[ri.index] = { ...ri, repairItemId: response.data.repairItemId };
          setValue(`${Number(ri.index)}.repairItemId`, response.data.repairItemId);
        }
        setItems(saveItem);
        enqueueSnackbar(ri.label ? `${ri.label} saved successfully! ` : 'Successful repair item save!', { variant: 'success' });
        return response.data.repairItemId;
      })
      .catch(() => {
        enqueueSnackbar('There was a problem saving the repair items. Please try again.', { persist: false, variant: 'error' });
        throw new Error('Unsuccessful save');
      });
    return result;
  };

  const saveRepairAdditionalFields = async (additionalFieldsParam: AdditionalField[]): Promise<string> => {
    const additionalFieldsRemap = additionalFieldsParam.map((af) => {
      if (af.fieldType === 'DateTime') {
        const fieldDate = new Date(af.fieldValue);
        fieldDate.setHours(0, 0, 0, 0);
        return { ...af, fieldValue: fieldDate };
      }
      return af;
    });
    const updateParam = { AdditionalProperties: additionalFieldsRemap, RepairId: repairId };
    const result = await axios.post<{ repairId: string }>('marker/UpdateAdditionalFields', updateParam)
      .then((response) => {
        enqueueSnackbar('Successful additional fields save!', { variant: 'success' });
        return response.data.repairId;
      })
      .catch(() => { throw new Error('Unsuccessful save of additional fields'); });
    return result;
  };

  const editRepairItem = async (repairItemParam: IRepairItem): Promise<string> => {
    if (repairItemParam.index === undefined) {
      enqueueSnackbar('Missing index needed for save', { variant: 'error' });
      throw new Error(`Missing index needed for save ${JSON.stringify(repairItemParam)}`);
    }
    const result = await axios.post<{ repairItemId: string }>('marker/updateRepairItem', repairItemParam)
      .then((response) => {
        enqueueSnackbar(repairItemParam.label ? `${repairItemParam.label} saved successfully!` : 'Successful repair item save!', { variant: 'success' });
        return response.data.repairItemId;
      })
      .catch(() => {
        enqueueSnackbar('There was a problem updating the repair items. Please try again.', { persist: false, variant: 'error' });
        throw new Error('Unsuccessful save');
      });
    return result;
  };

  const runPostSavePolicy = async (repairBarcodeParam: string): Promise<string> => {
    if (repairBarcodeParam === undefined) {
      enqueueSnackbar('Missing index needed for save', { variant: 'error' });
      throw new Error(`Missing index needed for save ${JSON.stringify(repairBarcodeParam)}`);
    }
    const result = await axios.post<{ Barcode: string }>('marker/runPostSavePolicy', { Barcode: repairBarcodeParam })
      .then((response) => response.data.Barcode)
      .catch(() => {
        enqueueSnackbar('There was a problem running the post repair policy method. Please try again.', { persist: false, variant: 'error' });
      });
    return result || '';
  };

  const onSubmit = async (repairInput: IRepairItemReactHookFormObject) => {
    const valid = await trigger(undefined, { shouldFocus: true });
    if (valid) {
      const repairObject = repairInput;
      const { additionalProperties } = repairObject;
      delete repairObject.additionalProperties;
      try {
        setRepairUpdating(true);
        if (additionalProperties) {
          // reattaching fieldType here is a bit janky
          const additionalFieldsArray = Object.entries(additionalProperties).map(
            ([fieldName, fieldValue]) => {
              const FieldType = data?.additionalProperties?.find((ad) => ad.fieldName === fieldName)?.fieldType || 'string';
              return (
                {
                  fieldName,
                  fieldValue: FieldType === 'DateTime' ? fieldValue : fieldValue.toString(),
                  fieldType: FieldType,
                });
            },
          );
          await saveRepairAdditionalFields(additionalFieldsArray);
        }
        const repairItemArray = Object.values(repairObject).map((ri: IRepairItem) => ri);
        if (repairItemArray.length > 1 && repairItemArray[0].label === undefined) {
          return;
        }
        for (let i = 0; i < repairItemArray.length; i += 1) {
          if (repairItemArray[i].repairItemId && repairItemArray[i].repairItemId !== '00000000-0000-0000-0000-000000000000') {
            if (formState?.dirtyFields
              && `${i}` in formState?.dirtyFields
            ) {
              // We want each item to save before the next loop starts
              // eslint-disable-next-line no-await-in-loop
              await editRepairItem(repairItemArray[i]);
            }
          } else {
            // If ring's diameter is null or empty, assign 0.
            if (repairItemArray[i].repairItemType?.label === 'Ring' && ((repairItemArray[i].stoneDiameter === null) || (repairItemArray[i].stoneDiameter === ''))) {
              repairItemArray[i].stoneDiameter = '0';
            }
            // We want each item to save before the next loop starts
            // eslint-disable-next-line no-await-in-loop
            await saveRepairItem(repairItemArray[i]);
          }
        }
        mutate().catch(() => {
          enqueueSnackbar('Error fetching repair items after save', { variant: 'error' });
        });
        // call post save function
        if (data?.barcode) {
          await runPostSavePolicy(data?.barcode);
        }
      } catch (e) {
        if (JSON.stringify(e) !== '{}') {
          enqueueSnackbar(JSON.stringify(e), { variant: 'error' });
        }
      } finally {
        setRepairUpdating(false);
      }
    }
  };

  const onInvalid = () => {
    trigger(undefined, { shouldFocus: true })
      .then(() => {
        const firstError: HTMLInputElement | null = document.querySelector('[aria-invalid="true"]');
        if (firstError) {
          firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
          setTimeout(() => { firstError.focus(); }, 500);
        }
      })
      .catch(() => { });
  };

  const { barcodeParam } = useParams();

  const scanBarcode = debounce((scannedBarcode: string) => {
    // if there's no content
    if (!scannedBarcode) {
      return;
    }
    scanRepair(scannedBarcode);
  }, 1000);

  const handleRoute = (barcodeRouteParam: string) => {
    switch (cookies.markerNextPage) {
      case 'Current': {
        break;
      }
      case 'Estimating': {
        navigate(`/estimate-repair/${barcodeRouteParam}`);
        break;
      }
      case 'Photography': {
        navigate(`/photograph-repair/${barcodeRouteParam}`);
        break;
      }
      default: {
        enqueueSnackbar(cookies.markerNextPage ? `Invalid barcode action page selected: ${cookies.markerNextPage}` : 'No next page action selected', { variant: 'error' });
        break;
      }
    }
  };

  // This method fetches MarkingFieldConfigurations.json file from Minio which is a config file that bounds all the min/max values for marking fields.
  const getContentFile = async (): Promise<string> => {
    const result = await Promise.resolve(axios.post<{ content: string }>('marker/getJsonContent', { fileName: 'MarkingFieldConfigurations.json' })
      .then((response) => response.data.content)
      .catch(() => {
        enqueueSnackbar('There was a problem fetching MarkingFieldConfigurations.json file.', { persist: false, variant: 'error' });
      }));
    return result || '';
  };

  // Convert content returned from Minio to JSON format and save it on a state.
  const convertJsonFile = async () => {
    const content = await getContentFile();
    if (content) {
      const serializedContent = JSON.parse(content);
      SetMarkingAcceptableBounds(serializedContent);
    }
  };

  // if a barcode came in as a url query
  React.useEffect(() => {
    // eslint-disable-next-line no-void
    void convertJsonFile();

    if (barcodeParam) {
      scanRepair(barcodeParam);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleOutScan = (scannedBarcode: string | '') => {
    console.log(scannedBarcode);
    axios.post('/scanner/LogManualScan', {
      ScanType: 'Out',
      ScanBody: scannedBarcode,
      Location: 'Marker',
    })
      .catch((er: AxiosError) => {
        enqueueSnackbar(er?.response?.data, { persist: false, variant: 'error' });
      });
  };

  let barcodeBuffer = '';
  const handleBarcodeInput = (e: KeyboardEvent) => {
    if (e.key !== 'Shift') {
      barcodeBuffer = `${barcodeBuffer}${e.key}`;
      if (barcodeBuffer.toLowerCase().includes('in:')) {
        deselectElementPreventDefaultAndBlur(e);
        barcodeBuffer = '';
      }
      if (barcodeBuffer.includes('{*|}')) {
        deselectElementPreventDefaultAndBlur(e);
        if (cookies.markerNextPage === 'Current' || data === undefined) {
          scanBarcode(barcodeBuffer.replace('{*|}', ''));
        } else {
          handleRoute(barcodeBuffer.replace('{*|}', ''));
        }
        barcodeBuffer = '';
      }
      if (barcodeBuffer.toLowerCase().includes('out:')) {
        deselectElementPreventDefaultAndBlur(e);
        barcodeBuffer = '';
      }
      if (barcodeBuffer.includes('<>??<>')) {
        deselectElementPreventDefaultAndBlur(e);
        handleOutScan(barcodeBuffer.replace('<>??<>', '') || '');
        barcodeBuffer = '';
      }
    }
  };

  useEventListener('keydown', handleBarcodeInput);

  if (!data) {
    return (
      <Grid container direction="column" spacing={2} alignItems="center" justifyContent="center">
        <Grid item>
          <Alert severity="info">{'To get started, scan in a repair.'}</Alert>
        </Grid>
        <Grid item>
          {openRepairProcessing
            ? (
              <CircularProgress />
            )
            : (
              <TextField
                variant="outlined"
                size="small"
                // onChange={(event) => scanBarcode(event.target.value)}
                onKeyPress={
                  (event) => {
                    if (event.key === 'Enter') {
                      event.preventDefault();
                      event.stopPropagation();
                      // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                      scanBarcode((event.target as HTMLInputElement).value);
                    }
                  }
                }
              />
            )}
        </Grid>
      </Grid>
    );
  }

  return (
    <>
      <Grid container spacing={0}>
        <Grid item xs={1} />
        <Grid container item xs={8} spacing={3}>
          <Grid item xs={12}>
            <Alert severity="info" id="info">
              {'Add repair items as necessary, and fill out necessary information based on repair type.'}
            </Alert>
          </Grid>
          <Grid item xs={12} md={6}>
            <RepairCard
              barcode={data.barcode}
              error={data.isHighPriority}
              primaryText="Current Repair"
              secondaryText="Barcode Number"
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography><b>{'Is this repair a possible redo?'}</b></Typography>
            <Box pt={2} alignItems="center" display="flex">
              <Box pr={1}>
                <ChipSelect label="No" selected={!data.isRedo} handleClick={() => handleRedoStateChange(false)} />
              </Box>
              <ChipSelect label="Yes" selected={data.isRedo} handleClick={() => handleRedoStateChange(true)} />
            </Box>
          </Grid>
          {
            hasWarranty
            && (
              <Grid item xs={12}>
                <Card>
                  <CardHeader title="Warranty Information" />
                  <Divider variant="fullWidth" />
                  <CardContent>
                    <Grid container spacing={3}>
                      {data?.claims && data.claims.map((value: IClaim) => (

                        <>
                          <Grid item xs={5}>
                            <TextField
                              fullWidth
                              variant="outlined"
                              label="Warranty Provider"
                              name={value.maintenanceAgreementProvider}
                              value={value?.maintenanceAgreementProvider}
                              disabled
                            />
                          </Grid>
                          <Grid item xs={5}>
                            <TextField
                              fullWidth
                              variant="outlined"
                              label="Warranty Number"
                              name={value.maintenanceAgreementNumber}
                              value={value?.maintenanceAgreementNumber}
                              disabled
                            />
                          </Grid>
                          <Grid item xs={2}>
                            <Box p={0.8}>
                              <ClearIcon htmlColor="#587B9F" fontSize="large" onClick={() => handleWarrantyDelete(value)} />
                            </Box>
                          </Grid>
                        </>
                      ))}
                      <Grid item xs={9} />
                      <Grid item xs={3}>
                        <Button fullWidth variant="contained" color="primary" onClick={() => setShowWarrantyModal(true)}>
                          {'Add Warranty'}
                        </Button>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
            )
          }
          <br />
          <Grid item xs={12}>
            <Paper style={{ backgroundColor: 'rgba(88, 123, 159,0.13)' }}>
              <Box p={2}>
                <Grid container>
                  <Grid item xs={6} style={{ backgroundColor: 'white' }}>
                    <TextField
                      id="item-value-input"
                      autoFocus
                      required
                      label="Item Value"
                      variant="outlined"
                      type="number"
                      inputRef={itemValueInputRef}
                      InputProps={{
                        startAdornment: <InputAdornment position="start">{'$'}</InputAdornment>,
                        onWheel: (e) => {
                          if (e.target instanceof HTMLElement) {
                            e.target.blur();
                          }
                        },
                      }}
                      // inputProps and InputProps are the actually different props, not sure why this rule is triggering https://github.com/mui-org/material-ui/issues/11377
                      // eslint-disable-next-line react/jsx-no-duplicate-props
                      inputProps={{
                        step: '0.01',
                        min: '0',
                      }}
                      disabled={repairValueProcessing}
                      fullWidth
                      error={itemValueError}
                      defaultValue={data.repairValue?.toFixed(2)}
                      onBlur={(event) => {
                        if (Number.parseFloat(event.target.value) > 0) {
                          if (itemValueInputRef?.current?.value != null) {
                            itemValueInputRef.current.value = `${Number.parseFloat(itemValueInputRef.current.value).toFixed(2)}`;
                            if ((Number.parseFloat(itemValueInputRef.current.value) !== data.repairValue)) {
                              handleRepairValueChange(itemValueInputRef.current.value);
                            }
                          } else {
                            handleRepairValueChange(event.target.value);
                          }
                        } else if (Number.parseFloat(event.target.value) !== data.repairValue) {
                          enqueueSnackbar('Cannot set a negative item value, resetting to original item value', { variant: 'error' });
                          if (itemValueInputRef?.current?.value != null) {
                            itemValueInputRef.current.value = `${data.repairValue}`;
                            setItemValueError(false);
                          }
                        }
                      }}
                      onChange={(event) => {
                        if (Number.parseFloat(event.target.value) < 0) {
                          setItemValueError(true);
                        } else {
                          setItemValueError(false);
                        }
                      }}
                    />
                  </Grid>
                  <Grid item xs={9} />
                </Grid>
              </Box>
            </Paper>
          </Grid>
          <br />
          <form noValidate onSubmit={handleSubmit(onSubmit, onInvalid)}>
            {(data.repairItems) ? items.map((e, i) => (
              <Grid item xs={12}>
                <Box p={1.5}>
                  <RepairItem
                    repairId={data.repairId}
                    index={i}
                    length={Math.min(items?.length, 10)}
                    repairItem={items[i]}
                    setFirstLabel={setFirstLabel}
                    isFirstItemLabelRequired={isFirstItemLabelRequired}
                    repairValue={data.repairValue}
                    openRepairValueModal={() => setShowValueRequiredModal(true)}
                    repairUpdating={repairUpdating}
                    setRepairUpdating={setRepairUpdating}
                    swrKey={random}
                    reactHookControl={control}
                    reactHookRegister={register}
                    reactHookSetValue={setValue}
                    markingBounds={markingAcceptableBounds}
                  />
                </Box>
              </Grid>
            ))
              : null}
            <Grid item xs={12} container justifyContent="center">
              <Grid item>
                <Tooltip title="Add another repair item" placement="top">
                  <IconButton onClick={handleAddNewItemClick} style={{ color: '#6CAE75', float: 'right' }} disabled={false}>
                    <AddCircleIcon fontSize="large" />
                  </IconButton>
                </Tooltip>
              </Grid>
            </Grid>
            {
              data?.additionalProperties && (
                <Grid item xs={12}>
                  <Box p={1.5}>
                    <Card>
                      <CardHeader title="Additional Fields" />
                      <Divider variant="fullWidth" />
                      <CardContent>
                        <Grid container spacing={2}>
                          {data?.additionalProperties
                            && data.additionalProperties
                              .map((additionalProp) => (
                                <MarkingAdditionalField
                                  reactHookControl={control}
                                  additionalProp={additionalProp}
                                />
                              ))}
                          <Grid item xs={9} />
                        </Grid>
                      </CardContent>
                    </Card>
                  </Box>
                </Grid>
              )
            }
            <Grid item xs={12} container direction="row-reverse">
              <Grid item>
                <Box clone py={1}>
                  <Button
                    variant="contained"
                    color="primary"
                    style={{ minWidth: '5.625rem' }}
                    type="submit"
                    disabled={repairUpdating
                      || repairValueProcessing
                      || Object.keys(formState?.dirtyFields).length === 0}
                  >
                    {repairUpdating ? <CircularProgress size={25} />
                      : 'Save'}
                  </Button>
                </Box>
              </Grid>
            </Grid>

          </form>
          <Grid item>
            <NavigationDropdown
              pageSelected={cookies.markerNextPage}
              pages={navPages}
              handlePageChange={handlePageSelectedChange}
            />
          </Grid>
        </Grid>
      </Grid>

      <MarkingModal
        barcode={data.barcode}
        showModal={showLabelRequiredModal}
        onClose={closeMarkingModal}
        dialogReason="label"
      />

      <MarkingModal
        barcode={data.barcode}
        showModal={showValueRequiredModal}
        onClose={() => setShowValueRequiredModal(false)}
        dialogReason="value"
      />

      <WarrantyDialog
        barcode={data.barcode}
        showModal={showWarrantyModal}
        toggleModal={setShowWarrantyModal}
        addWarranty={handleWarrantyAdd}
      />
    </>
  );
};

export default Marking;
